import type { AppSpec } from 'api';

import type { BaseConfig } from '@izimi/core';
import { appEnv, notaryApiUrl } from '@izimi/core';

import packageJSON from '../../../../../package.json';

class Config implements BaseConfig {
  constructor(public apiUrl: string) {}

  get environment() {
    return appEnv;
  }

  get contactEmail() {
    return 'servicedesk@fednot.be';
  }

  get supportPhone() {
    return '+3225050880';
  }

  get supportPhoneFormatted() {
    return '+32 2 505 08 80';
  }
}

const configs: Record<'local' | 'development' | 'test' | 'acc' | 'production', Config> = {
  local: new Config(notaryApiUrl.local),
  development: new Config(notaryApiUrl.development),
  test: new Config(notaryApiUrl.test),
  acc: new Config(notaryApiUrl.acc),
  production: new Config(notaryApiUrl.production),
};

export const appSpec: AppSpec = { app: 'web-notary', version: packageJSON.version };

export default configs[appEnv];
